// Firestore I/O for app-wide notification recipient settings.
// Separate recipient lists for Listing Requests (seller side) vs Buyer
// Requests. Stored at appSettings/listingRequestNotifications with shape
// { seller: [...userIds], buyer: [...userIds] }.
//
// Backwards-compat: older docs used a flat `userIds` array — read that as
// BOTH seller and buyer lists so nobody loses coverage during the migration.

import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { firestored } from "../firebase/firebaseConfig";

const DOC_PATH = ["appSettings", "listingRequestNotifications"];

export async function loadListingRequestRecipients() {
  try {
    const snap = await getDoc(doc(firestored, ...DOC_PATH));
    if (!snap.exists()) return { seller: [], buyer: [] };
    const data = snap.data();
    // New shape wins; otherwise migrate legacy flat userIds into both lists.
    if (Array.isArray(data.seller) || Array.isArray(data.buyer)) {
      return {
        seller: Array.isArray(data.seller) ? data.seller : [],
        buyer: Array.isArray(data.buyer) ? data.buyer : [],
      };
    }
    const legacy = Array.isArray(data.userIds) ? data.userIds : [];
    return { seller: legacy, buyer: legacy };
  } catch (err) {
    console.error("loadListingRequestRecipients failed:", err);
    return { seller: [], buyer: [] };
  }
}

export async function saveListingRequestRecipients(
  { seller, buyer },
  savedBy,
) {
  await setDoc(
    doc(firestored, ...DOC_PATH),
    {
      seller: Array.isArray(seller) ? seller : [],
      buyer: Array.isArray(buyer) ? buyer : [],
      updatedAt: serverTimestamp(),
      updatedBy: savedBy || null,
    },
    { merge: true },
  );
}
